import classNames from 'classnames';
import { FC } from 'react';

export interface DividerProps {
  className?: string;
  backgroundImage?: string;
}

const Divider: FC<DividerProps> = ({ className, backgroundImage }) => {
  return (
    <div
      role="presentation"
      className={classNames('h-10 w-full bg-cover bg-no-repeat', className)}
      style={{
        backgroundImage:
          backgroundImage || `url(/assets/images/dot-divider.png)`,
      }}
    />
  );
};

export default Divider;
